import React from "react";
import AboutUs_Owners01 from "../PicsForPages/AboutUs_Owners01.webp";
import AboutUs_Owners02 from "../PicsForPages/AboutUs_Owners02.webp";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function AboutUs() {
  UseScrollAnimation(); // ✅ just call it
  return (
    <div className="AboutUsParent">
      <div className="AboutUsBox">
        <div className="AboutUsBoxHeading">
          <span className="AboutUsBoxHeadingWord animate-top">About Us</span>
          <span className="AboutUsBoxHeadingLine animate-top"></span>
        </div>
        <div className="AboutUsBoxContentBox">
          <div className="AboutUsBoxContentBoxPara animate-top">
            Welcome to Cornelius Woods, a premium 55+ active adult retirement
            community nestled in the heart of Cornelius, North Carolina. We are
            a community defined by comfort, convenience, and luxury, where every
            detail is meticulously crafted to enhance your retirement lifestyle.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            Our journey began with a vision to create an exclusive haven for
            active adults seeking a relaxed, yet vibrant, lifestyle. At
            Cornelius Woods, we've brought this vision to life, providing
            upscale condominium living in an environment that fosters community,
            encourages activity, and celebrates individuality.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            Our residences, ranging from one to three bedrooms, showcase
            thoughtful design and high-quality finishes. Each home is carefully
            planned to offer spacious living areas, modern amenities, and
            private outdoor spaces. Whether you are hosting family, spending a
            quiet evening at home, or simply enjoying your morning coffee on the
            patio, Cornelius Woods is your canvas to craft a lifestyle that
            reflects your aspirations and preferences.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            Beyond our residences, Cornelius Woods boasts a multitude of
            exterior amenities designed to promote an active and social
            lifestyle. From our fenced dog park and pickleball courts to our
            walking trails and community garden, we've thought of everything to
            make your retirement rich and fulfilling. Moreover, our commitment
            to sustainable living is evident through facilities such as electric
            vehicle charging stations and covered parking.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            Our location in Cornelius provides easy access to local attractions
            like Birkdale Village, Antiquity, and Jetton Park, as well as a
            range of top-notch restaurants and local establishments. So whether
            you're in the mood for a day of shopping, an evening of fine dining,
            or a leisurely stroll in the park, everything you desire is just
            moments away.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            At Cornelius Woods, we believe in building more than just homes; we
            aim to foster a sense of community. Our commitment to delivering a
            premier living experience is visible in every facet of our
            community, and our dedicated team is always available to ensure your
            comfort and satisfaction.
          </div>
          <div className="AboutUsBoxContentBoxPara animate-top">
            Step into Cornelius Woods, where your retirement is more than just a
            chapter; it's a lifestyle. Welcome to our community. Welcome home.
          </div>
        </div>
        <div className="AboutUsBoxHeading">
          <span className="AboutUsBoxHeadingWord animate-top">
            Meet the Owners
          </span>
          <span className="AboutUsBoxHeadingLine animate-top"></span>
        </div>
        <div className="AboutUsBoxOwnersParent">
          <div className="AboutUsBoxOwnersBox">
            <img
              fetchPriority="high"
              loading="eager"
              src={AboutUs_Owners01}
              alt="AboutUsBoxOwnersBoxImage"
              className="AboutUsBoxOwnersBoxPic animate-top"
            />
          </div>
          <div className="AboutUsBoxOwnersBox">
            <div className="AboutUsBoxHeading">
              <span className="AboutUsBoxHeadingWord animate-top">
                Wyatt Clark Sr.
              </span>
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Wyatt Clark, Sr., is a veteran in the building industry with over
              four decades of experience. As a licensed General Contractor in
              North Carolina and the owner of WAC Contracting Inc, Wyatt has
              been a driving force in the construction and development landscape
              in the state and beyond.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Wyatt's journey began in 1980 when he built his first home for his
              family, igniting a passion for construction that's stayed with him
              ever since. That same year, he joined Kal-Mar Construction in
              Tampa, Florida, as a Project Manager, overseeing a range of
              residential and commercial projects and honing his skills in all
              facets of the building industry.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              In 1989, Wyatt and his family relocated to Charlotte, North
              Carolina, where he co-founded his first construction company.
              Despite handling both residential and commercial projects, Wyatt
              found himself particularly drawn to the residential side of the
              business.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              His passion for residential construction led him to establish WAC
              Contracting, Inc. in 2007, when he and his wife moved to Lake
              Norman, North Carolina. Specializing in residential new
              construction, high-end renovations, and community development, WAC
              Contracting Inc has been recognized with several awards by the
              National Association of the Remodeling Industry.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              As a visionary leader, Wyatt has steered WAC Contracting Inc to
              develop two thriving adult communities. Magnolia Glenn, a private
              gated community in Statesville, North Carolina, features 16 custom
              residential homes, some of which Wyatt is still actively building
              today. More recently, Wyatt has partnered in the development of
              Cornelius Woods, a community of 111 luxurious senior living
              condominiums in historic downtown Cornelius, North Carolina. From
              the land purchase in 2018 to the design, engineering, financing,
              marketing, and building of the sales team, Wyatt has been
              instrumental in bringing the Cornelius Woods vision to life.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              With a lifelong motto of "It's a beautiful day, LIVE IT!", Wyatt
              Clark, Sr. brings enthusiasm, passion, and a wealth of hands-on
              experience to every project he undertakes. His commitment to
              quality and his unwavering dedication to the craft of building
              continue to shape North Carolina's residential construction and
              development landscape.
            </div>
          </div>
        </div>
        <div className="AboutUsBoxOwnersParent">
          <div className="AboutUsBoxOwnersBox">
            <div className="AboutUsBoxHeading">
              <span className="AboutUsBoxHeadingWord animate-top">
                Rama Yada
              </span>
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Rama Yada is a real estate titan with a career that spans over 17
              years. Since launching his career in 2006, Rama has built a
              substantial portfolio and reputation in the industry, showcasing
              his keen business acumen and extensive expertise in real estate
              development and investment.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              His entrepreneurial journey began with the development of numerous
              gas stations and convenience stores across North Carolina,
              Georgia, and Virginia. This laid the foundation for his ventures
              into multi-family development, acquisition, entitlement,
              syndication, joint ventures, and construction management.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Rama's portfolio is impressive and diverse, having sourced,
              negotiated, developed, acquired, and partnered in over 135,000 sq.
              ft. of commercial space and 1,000 units of multifamily housing in
              North Carolina. Today, he owns and manages a formidable real
              estate portfolio worth over $300 million, comprising land,
              multifamily housing, townhomes, shopping centers, and convenience
              stores.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              With investments spanning across the globe, Rama has built a vast
              network of developers, investors, and commercial lenders,
              fortifying his position in the industry. His multinational
              presence and multifaceted experience make him a distinguished
              figure in the real estate landscape.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Rama's educational background complements his professional
              accomplishments. He holds a bachelor's degree in Civil Engineering
              from Nagarjuna University, and is currently pursuing his MBA from
              the prestigious NYU Stern School for Business. This combination of
              practical experience and academic insights enhances his strategic
              vision and operational efficiency.
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Some of Rama’s significant multifamily projects include:
            </div>
            <div className="AboutUsBoxOwnersBoxPara AboutUsBoxOwnersBoxPara00">
              <span className="animate-top">
                Hyde Glen Apartments (Charlotte, NC)
              </span>
              <span className="animate-top">
                Villas at Erwin (Charlotte, NC)
              </span>
              <span className="animate-top">
                Luxury Townhomes- Ballantyne (Charlotte, NC)
              </span>
              <span className="animate-top">
                Apartments at Pleasant Grove (Charlotte, NC)
              </span>
              <span className="animate-top">
                Mount Holly Town Homes (Charlotte, NC)
              </span>
              <span className="animate-top">
                Bell Haven Town Homes (Charlotte, NC)
              </span>
              <span className="animate-top">
                Apartments at Orphanage Road (Kannapolis, NC)
              </span>
              <span className="animate-top">
                Steele Creek Apartments (Charlotte, NC)
              </span>
            </div>
            <div className="AboutUsBoxOwnersBoxPara animate-top">
              Rama is more than a successful real estate entrepreneur. He is a
              visionary who creates communities, contributing to the growth and
              development of neighborhoods across various regions. His passion,
              determination, and leadership continue to drive his success,
              making him a respected and influential figure in the world of real
              estate.
            </div>
          </div>
          <div className="AboutUsBoxOwnersBox">
            <img
              fetchPriority="high"
              loading="eager"
              src={AboutUs_Owners02}
              alt="AboutUsBoxOwnersBoxImage"
              className="AboutUsBoxOwnersBoxPic animate-top"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
